import React, {useEffect} from "react"
import MutiColorBarChart from "../Charts/BarChart/MultiColorBarChart"
import {shortenNumber} from "../../utils/utils"
import ChartContainer from "../Charts/ChartContainer"
import {useManualQuery} from "graphql-hooks"
import {UseStores} from "../../hooks/UseStores"
import {observer} from "mobx-react-lite"
import {MONTHLY_TREND_QUERY} from "../../gql/gqlInsights"
import {insightClient} from "../../gql/gqlInterceptor"
import {brandIdToSicCode} from "../../utils/utils"
import {Spinner} from "../Spinner"
import InternalError from "../InternalError"
import dayjs from "dayjs"
import {gtBlue} from "../../assets/shared/colorConstants"
import EmptyDataContainer from "../../pages/Insights/EmptyDataContainer"
import "./index.scss"

const MonthlyVisits = () => {
  let domChart = null
  let query = MONTHLY_TREND_QUERY
  const label = "Monthly Visits"
  const type = "monthly_visits"
  const {insightStore, insightsPopupStore} = UseStores()
  const brandId = insightStore.brandId
  const sicCode = brandIdToSicCode(brandId)
  const month = insightStore.insightMonth
  const marketType = insightStore.insightMarketType
  const marketTypeValue = insightStore.insightMarketTypeValue
  const skipCache = insightsPopupStore.skipCacheForMonthlyVisits
  const csvData = []
  const chartData = []
  let maxShare = null
  let minShare = null
  const [fetchData, {loading, error, data}] = useManualQuery(query, {
    variables: {brandId, sicCode, month, marketType, marketTypeValue},
    client: insightClient,
    skipCache: skipCache,
  })

  useEffect(() => {
    if (month !== "") {
      fetchData()
    }
  }, [month, sicCode, brandId, marketType, marketTypeValue])

  if (loading) {
    domChart = (
      <div align="center">
        <Spinner size="medium" />
      </div>
    )
  }

  if (error) {
    insightsPopupStore.setSkipCacheForMonthlyVisits(true)
    domChart = (
      <div className="error-message-container">
        <InternalError />
      </div>
    )
  }

  if (data && data.marketShare) {
    insightsPopupStore.setSkipCacheForMonthlyVisits(false)
    const monthlyVisitList = []
    const monthlyTrend = data.marketShare.marketShareTrend.monthlyTrend
    if (monthlyTrend.length === 0) {
      domChart = <EmptyDataContainer />
    } else {
      const brandName = monthlyTrend[0].brand.brandName
      for (let i = 0; i < monthlyTrend.length; i++) {
        const brandVisit = Number(monthlyTrend[i].brand["visits"])
        monthlyVisitList.push(brandVisit)
        csvData.push({
          "": i + 1,
          Month: dayjs(monthlyTrend[i].month).format("MMMM YYYY"),
          "Market Share": `${brandVisit}`,
        })
        chartData.push({
          Month: dayjs(monthlyTrend[i].month).format("MMMM YYYY"),
          [brandName]: brandVisit,
        })
      }
      if (monthlyVisitList.length) {
        minShare = `${shortenNumber(Math.min(...monthlyVisitList), 1)}`
        maxShare = `${shortenNumber(Math.max(...monthlyVisitList), 1)}`
      }
      domChart = (
        <div>
          <MutiColorBarChart
            chartData={chartData}
            xDataKey="Month"
            yDataKey={brandName}
            labelList={true}
            barSize={90}
            chartHeight={272}
            showLegend={true}
            shortenLabelValue={true}
            color={gtBlue}
            marginTop={40}
          />
        </div>
      )
    }
  }

  return (
    <ChartContainer
      type={type}
      csvData={csvData}
      label={label}
      hideDownload={true}
      showMinMax={error ? false : true}
      max={maxShare}
      min={minShare}
    >
      {domChart}
    </ChartContainer>
  )
}
export default observer(MonthlyVisits)
